'use client';

import { c as _c } from "react/compiler-runtime";
export function InitialBadge(t0) {
  const $ = _c(4);
  const {
    name
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = name.split(" ").map(_temp).join("").slice(0, 2);
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex size-11 shrink-0 items-center justify-center rounded-full border border-[#24122f] bg-[#f8efe0] text-sm font-black text-[#24122f] shadow-[3px_3px_0_#24122f]">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(part) {
  return part[0];
}